/**
 * Enlaces opcionales para Firebase Auth (reset password).
 * Si NO definís REACT_APP_AUTH_CONTINUE_URL, el envío usa el comportamiento por defecto
 * de Firebase (suele ser más fiable que forzar una URL incorrecta).
 *
 * Si definís la variable, el dominio debe estar en Authentication → Dominios autorizados.
 */
export function getOptionalPasswordResetActionCodeSettings() {
  const fromEnv = process.env.REACT_APP_AUTH_CONTINUE_URL;
  if (!fromEnv || !String(fromEnv).trim()) {
    return null;
  }
  const base = String(fromEnv).trim().replace(/\/$/, "");
  return {
    url: `${base}/`,
    handleCodeInApp: false,
  };
}
